import { Avatar, Box, Chip, Stack, Typography } from '@mui/material'
import SchoolIcon from '@mui/icons-material/School'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import { tokens } from '../lib/tokens'

function SectionHeader({ children }: { children: React.ReactNode }) {
  return (
    <Typography
      fontFamily='"Manrope", sans-serif'
      fontSize="0.625rem"
      fontWeight={700}
      textTransform="uppercase"
      letterSpacing="0.12em"
      color={`${tokens.secondary}99`}
      mb={1.5}
    >
      {children}
    </Typography>
  )
}

interface TrainingSectionProps {
  heading: string
  label: string
  description?: string | null
}

export function TrainingSection({ heading, label, description }: TrainingSectionProps) {
  return (
    <Box>
      <SectionHeader>{heading}</SectionHeader>
      <Stack direction="row" flexWrap="wrap" gap={1}>
        <Chip
          icon={<SchoolIcon sx={{ fontSize: 16 }} />}
          label={`${label}${description ? ` — ${description}` : ''}`}
          sx={{
            bgcolor: tokens.surfaceContainerLow,
            color: tokens.onSurfaceVariant,
            fontSize: '0.8125rem',
            fontWeight: 500,
            height: 'auto',
            py: 0.5,
            '& .MuiChip-icon': { color: tokens.primary },
          }}
        />
      </Stack>
    </Box>
  )
}

interface ClinicSectionProps {
  heading: string
  cabinetLabel: string
  addresses: Array<{ description?: string | null }>
}

export function ClinicSection({ heading, cabinetLabel, addresses }: ClinicSectionProps) {
  return (
    <Box>
      <SectionHeader>{heading}</SectionHeader>
      <Stack direction="row" alignItems="center" spacing={2} sx={{ p: 2, bgcolor: tokens.surfaceContainerLow, borderRadius: 4 }}>
        <Box flex={1}>
          <Typography fontWeight={500} fontSize="0.875rem" color={tokens.onSurface}>
            {cabinetLabel}
          </Typography>
          {addresses.map((addr, idx) => (
            <Typography key={idx} fontSize="0.8125rem" color={tokens.secondary} mt={0.25}>
              {addr.description}
            </Typography>
          ))}
        </Box>
        <Avatar sx={{ width: 40, height: 40, bgcolor: tokens.surfaceContainer, color: tokens.primaryContainer }}>
          <LocationOnIcon sx={{ fontSize: 20 }} />
        </Avatar>
      </Stack>
    </Box>
  )
}
